import LayoutSidebar from "../../components/layoutSidebar/layoutSidebar";
import Artist from "../../components/artist/artist";

const Artists = () => {
  return (
    <>
      <LayoutSidebar>
        <Artist />
      </LayoutSidebar>
    </>
  )
}
export default Artists;